import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import Strategy from 'components/Cards/Strategy';
import {getFollowingStrategies} from 'selectors/followingStrategies';

import '../style.scss';

const FollowingStrategies = ({followingStrategies}) => (
  <div className="strategies-page">
    <div className="page-description">Strategies followed by you.</div>
    {followingStrategies.length ? (
      followingStrategies.map(strategy => <Strategy key={strategy.id} strategy={strategy} strategyId={strategy.id} />)
    ) : (
      <div className="message">
        <Link to="/strategies">Explore</Link> top strategies!
      </div>
    )}
  </div>
);

export default connect(state => ({
  followingStrategies: getFollowingStrategies(state),
}))(FollowingStrategies);
